/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Pencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Pencil"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="m3.726 15.095 8.631-8.631 5.18 5.179-8.632 8.63z"
      />
      <path
        fill="#DADADA"
        d="m12.358 6.464 2.589-2.59 5.179 5.18-2.59 2.589z"
      />
      <path
        fill="#F50"
        d="m14.947 3.874 1.369-1.368a1.726 1.726 0 0 1 2.44 0l2.738 2.737a1.726 1.726 0 0 1 0 2.441l-1.368 1.37z"
      />
      <path
        fill="#FFF3D2"
        d="m2 22 1.726-6.905h1.727v1.726h1.726v1.726h1.726v1.727z"
      />
      <path fill="#0E0E0E" d="m2 22 .863-3.453 2.59 2.59z" />
    </g>
  </svg>
);

export const PencilIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'pencil-icon'}
      icon={Pencil}
      {...props}
      size={size}
    />
  );
};
